import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=8efba110&scoped=true&"
import script from "./competition.vue?vue&type=script&lang=js&"
export * from "./competition.vue?vue&type=script&lang=js&"
import style0 from "./competition.vue?vue&type=style&index=0&id=8efba110&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8efba110",
  null
  
)

export default component.exports